/* eslint-disable arrow-body-style */
import HttpClient from 'services/api';
import { ENDPOINTS } from 'services/api/endpoints';

// const config = {
//   headers: {
//     'Content-Type': 'multipart/form-data',
//   },
// };

const CUSTOM_TIMEOUT = 40000; // 40s

// Retorno FGTS por ID
export const getFgtsById = (id) => (HttpClient.get(ENDPOINTS.FGTS.concat(`${id}/`)));

// Deleta FGTS por ID
export const deleteFgtsById = (id) => (HttpClient.delete(ENDPOINTS.FGTS.concat(`${id}/`)));

// Valida os extratos (PDFs)
export const checkFiles = (payload, idToken) => {
  return (HttpClient.post(ENDPOINTS.CHECK_FILES, payload, { idToken }, CUSTOM_TIMEOUT));
};

// Upload dos extratos (PDFs)
export const uploadFiles = (payload, idToken) => {
  return (HttpClient.post(ENDPOINTS.UPLOAD_FILES, payload, { idToken }, CUSTOM_TIMEOUT));
};
